import React from 'react';
import { RiFilterLine, RiCheckLine, RiArrowDownSLine, RiFileList3Line, RiTimeLine, RiCheckboxCircleLine, RiCloseCircleLine, RiHistoryLine } from '@remixicon/react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from '@components/ui/DropdownMenu';
import Button from '@components/ui/Button';
import { Badge } from '@components/ui/Badge';

/**
 * BidFilters Component
 * Modern dropdown filter for bids using AlignUI components
 *
 * @param {Object} props
 * @param {string} props.activeFilter - Currently active filter
 * @param {Function} props.onFilterChange - Callback when filter changes
 * @param {number} props.totalCount - Total count of bids for current filter
 */
const BidFilters = ({ activeFilter = 'all', onFilterChange, totalCount = 0 }) => {
  const filters = [
    { value: 'all', label: 'All Bids', icon: RiFileList3Line },
    { value: 'pending', label: 'Pending', icon: RiTimeLine },
    { value: 'accepted', label: 'Accepted', icon: RiCheckboxCircleLine },
    { value: 'rejected', label: 'Rejected', icon: RiCloseCircleLine },
    { value: 'expired', label: 'Expired', icon: RiHistoryLine },
  ];

  const handleFilterChange = (value) => {
    if (onFilterChange) {
      onFilterChange(value);
    }
  };

  const getActiveFilterLabel = () => {
    const filter = filters.find((f) => f.value === activeFilter);
    return filter ? filter.label : 'All Bids';
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 px-3.5 py-2 bg-white rounded-full border border-gray-300 hover:border-gray-400 hover:shadow-sm transition-all">
          <RiFilterLine className="w-4 h-4 text-gray-600" />
          <span className="text-sm font-medium text-gray-800">{getActiveFilterLabel()}</span>
          {totalCount > 0 && (
            <span className="ml-0.5 px-2 py-0.5 bg-gray-100 text-gray-700 text-xs font-semibold rounded-full min-w-[20px] text-center">
              {totalCount}
            </span>
          )}
          <RiArrowDownSLine className="w-4 h-4 text-gray-500 ml-0.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-xs text-gray-500 uppercase tracking-wide">
          Filter Bids
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={activeFilter} onValueChange={handleFilterChange}>
          {filters.map((filter) => {
            const IconComponent = filter.icon;
            return (
              <DropdownMenuRadioItem
                key={filter.value}
                value={filter.value}
                className="cursor-pointer"
              >
                <IconComponent className="w-4 h-4 mr-2" />
                <span>{filter.label}</span>
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default BidFilters;
